function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { captureException as sentryCaptureException, addBreadcrumb, BrowserClient, withScope, Hub } from "@sentry/browser";
import { load } from "isomorphic-cookie";
import { getCorrelationId, getUsrLocale, getJSessionId } from "./utils";
if (process.browser) {
    if (!window.sentryHub) {
        window.sentryHub = {};
    }
} else {
    global.sentryHub = global.sentryHub ? global.sentryHub : {};
}
export var federatedSentry = function(options) {
    var _options;
    var name = (_options = options) == null ? void 0 : _options.name;
    if (name) {
        delete options.name;
    }
    if (typeof process.env.CURRENT_HOST !== "undefined" && !name) {
        name = process.env.CURRENT_HOST;
    }
    if (typeof window !== "undefined" && options) {
        options.beforeSend = function(event) {
            var request = {
                url: window.location.href,
                headers: {
                    "User-Agent": navigator.userAgent
                }
            };
            if (event.request) {
                Object.assign(event.request, request);
            } else {
                event.request = request;
            }
            return event;
        };
    }
    if (!sentryHub[name] && process.browser && options.enabled && options.dsn) {
        // const client = process.browser
        //   ? new Sentry.BrowserClient(options)
        //   : new Sentry.NodeClient(options);
        var client = new BrowserClient(options);
        sentryHub[name] = new Hub(client);
    }
};
export var withSharedReporting = function(scope, extra, host, req, federationConsumer) {
    var correlationId = getCorrelationId(req) || "nonprod";
    var jSessionId = getJSessionId(req) || "nonprod";
    var usrLocale = getUsrLocale(req) || "null";
    try {
        var _localStorage_getItem;
        var isLoggedIn = !!load("isLoggedin", req);
        scope.setTag("isLoggedIn", isLoggedIn);
        var oktaSession = !!process.browser ? (_localStorage_getItem = localStorage.getItem("okta-token-storage")) == null ? void 0 : _localStorage_getItem.length : load("okta-token-storage", req);
        var hasOktaSession = oktaSession > 50;
        scope.setTag("hasOktaSession", hasOktaSession);
        var ltmo = load("ltmo", req);
        scope.setTag("ltmo", ltmo);
        // If the chunk was federated, tag the consuming application
        if (!!federationConsumer) {
            scope.setTag("federationConsumer", federationConsumer);
        }
        if (extra && extra instanceof Object && extra.constructor === Object) {
            var breadcrumb = extra.breadcrumb, tags = extra.tags;
            if (tags) {
                Object.entries(tags).forEach(function(param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    return scope.setTag(key, value);
                });
            }
            if (breadcrumb) {
                var _sentryHub_host, _sentryHub;
                var sentryBreadcrumb = ((_sentryHub = sentryHub) == null ? void 0 : (_sentryHub_host = _sentryHub[host]) == null ? void 0 : _sentryHub_host.addBreadcrumb) || addBreadcrumb;
                sentryBreadcrumb(_extends({}, breadcrumb));
            }
        }
    } catch (error) {
        console.error(error);
    }
    scope.setTag("correlationId", correlationId);
    scope.setTag("jSessionId", jSessionId);
    scope.setTag("userLocale", usrLocale);
};
export var captureException = function(err, level, extra, host) {
    if (level === void 0) level = "error";
    if (typeof process.env.CURRENT_HOST !== "undefined" && !host) {
        host = process.env.CURRENT_HOST;
    }
    if (process.env.NODE_ENV === "development") {
        console.error("\uD83D\uDC82", err);
    }
    try {
        window.sentryHub[host].withScope(function(scope) {
            scope.setLevel(level);
            withSharedReporting(scope, extra, host);
            window.sentryHub[host].captureException(err);
        });
    } catch (e) {
        withScope(function(scope) {
            scope.setLevel(level);
            withSharedReporting(scope, extra, host);
            sentryCaptureException(err);
        });
    }
};
/**
 * Sends reports to Sentry
 *  @param {{err: Error, details: object, extra: object, req: object, remoteHost: object, sentryLevel: string}}
 */ var sendToSentry = function(param) {
    var err = param.err, details = param.details, extra = param.extra, req = param.req, remoteHost = param.remoteHost, sentryLevel = param.sentryLevel;
    var host = typeof process.env.CURRENT_HOST !== "undefined" && !remoteHost ? process.env.CURRENT_HOST : remoteHost;
    var federationConsumer = remoteHost && process.env.CURRENT_HOST;
    try {
        window.sentryHub[host].withScope(function(scope) {
            scope.setLevel(sentryLevel);
            withSharedReporting(scope, extra, host, req, federationConsumer);
            if (details) {
                scope.setExtra("details", details);
            }
            window.sentryHub[host].captureException(err);
        });
    } catch (e) {
        withScope(function(scope) {
            scope.setLevel(sentryLevel);
            withSharedReporting(scope, extra, host, req, federationConsumer);
            if (details) {
                scope.setExtra("details", details);
            }
            sentryCaptureException(err);
        });
    }
};
/**
 * @param level {{sentry: string, browser: string}}
 * @returns {(err: Error, details: object, extra: object, req: object, remoteHost: string) => void}
 */ var logger = function(level) {
    return function(err, details, extra, req, remoteHost) {
        if (req === void 0) req = {};
        if (level.browser === "error" || level.browser === "warn") {
            sendToSentry({
                err: err,
                details: details,
                extra: extra,
                req: req,
                remoteHost: remoteHost,
                sentryLevel: level.sentry
            });
        }
        /* eslint-disable no-console */ if (process.env.NODE_ENV === "development") {
            console.error("\uD83D\uDC82", {
                err: err,
                details: details,
                extra: extra
            });
        } else if (console[level.browser]) {
            console[level.browser](err, details);
        } else {
            console.log(err, details);
        }
    /* eslint-enable no-console */ };
};
/**
 * Use "fatal" for critical errors that should never occur, and we need to be alerted.
 * Use "error" for issues that shouldn't occur, but it's not app breaking, and we can investigate it on Sentry.
 * Use "warn" for issues that should not page anyone, is handled but you would like more information on why it's occuring.
 * Use "info" or "debug" for local logging only. These do not get sent to Sentry.
 * @type {Record<'fatal'| 'error'| 'warning'| 'info'| 'debug', (err: Error, details: object, extra: object, req: object, remoteHost: string) => void>}
 */ export var log = {
    fatal: logger({
        sentry: "fatal",
        browser: "error"
    }),
    error: logger({
        sentry: "error",
        browser: "error"
    }),
    warning: logger({
        sentry: "warning",
        browser: "warn"
    }),
    info: logger({
        sentry: "info",
        browser: "info"
    }),
    debug: logger({
        sentry: "debug",
        browser: "log"
    })
};
